// pages/Login/TwoFactorAuthentication.tsx
import React from 'react';
import { Shield } from 'lucide-react';
import { Button, TwoFactorSelect } from 'shared-portal-components-v2';

import { useAuth2FASelect } from '@/hooks/auth/useAuth2FASelect';

const TwoFactorAuthentication: React.FC = () => {
  const { state, handlers } = useAuth2FASelect();

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    handlers.handleSendCode();
  };

  return (
    <form className="w-full" onSubmit={handleSubmit}>
      <div className="text-center">
        <div className="flex items-center justify-center mb-4">
          <div className="bg-accent/10 p-3 rounded-full">
            <Shield className="w-8 h-8 text-accent" aria-hidden="true" />
          </div>
        </div>

        <h1 className="text-3xl font-bold text-foreground">Two-Factor Authentication</h1>
        <p className="mt-2 text-muted-foreground text-lg">
          Choose how you'd like to receive your security code.
        </p>
      </div>

      <div className="mt-8">
        <TwoFactorSelect
          value={state.selectedMethod}
          onValueChange={handlers.handleMethodChange}
          isDisabled={state.isLoading}
        />
      </div>

      <div className="mt-6 pt-2 flex flex-col gap-4">
        <Button
          type="submit"
          variant="primary"
          size="lg"
          className="w-full h-12 text-base font-semibold"
          isLoading={state.isLoading}
          disabled={state.isLoading}
        >
          Send Code
        </Button>
      </div>
    </form>
  );
};

export default TwoFactorAuthentication;
